import { setDates } from "@omnia/shared/utils/date"
import { convertDatesToJsonUtc, IOmniaHttpService, IOmniaSession, selectMany } from "../omnia"
import { INutritionTemplate, IPlanTemplateService } from "../types"

export class PlanTemplateService implements IPlanTemplateService {

    static $inject = [
        "OmniaSession",
        "OmniaHttpService"
    ]

    constructor(private session: IOmniaSession, private ohttp: IOmniaHttpService) {
    }

    getTemplates(): ng.IPromise<INutritionTemplate[]> {

        let userId = this.session.currentUser.Id

        let url = "/api/nutrition/plan/template/get/" + userId

        return this.ohttp.get(url).then(r => {
            var templates = r.data

            if (templates) {
                setDates(selectMany(templates.map(t => t.Applications)), ["ApplicationDate"], true)
            }

            return templates
        })
    }

    saveTemplate(template: INutritionTemplate): ng.IPromise<any> {
        const url = "/api/nutrition/plan/template/save"

        // Clean
        template.Applications.forEach(a => a.FertiliserProduct = undefined)

        convertDatesToJsonUtc(template)

        return this.ohttp.post(url, template)
    }

    deleteTemplate(templateId: number): ng.IPromise<any> {
        const url = `/api/nutrition/v2/plan/template/delete?templateId=${templateId}`
        return this.ohttp.delete(url)
    }

}
